<template>
  <div id="ads">
    <!-- Modal Component -->
    <b-modal ref="myModalRef" id="modal-center" size="lg" centered>
      <div class="col-lg-5 pic" style="padding-left: 0px; padding-right: 0px">
        <img style="width: 100%" :src="'static/image/eventi/'+evento.image">
      </div>
      <div class="col-lg-7 subscribe">
        <div style="position: absolute;right: 7pt;top: 0px;">
          <b-button @click="dontShowModal()" class="closeButton">x</b-button>
        </div>
        <p class="title">{{evento.title}} - {{formatDateStampa(evento.dateFrom)}}</p>
        <p class="text" v-html="evento.shortDesc"></p>
        <div class="iscriviti">
          <b-button :to="{name: 'eventiregistrazione', params: {id: evento.id, language: evento.language}}"
                    variant="outline-success" state="false" class="bottone">
            Vai all' evento!
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>

</template>

<script>
  import moment from 'moment'

  export default {
    name: "ads",
    data() {
      return {}
    },
    props: {
      evento: {type: Object}
    },
    mounted: function () {
      this.showModal()
    },
    methods: {
      showModal() {
        this.$refs.myModalRef.show()
      },
      dontShowModal() {
        this.$refs.myModalRef.hide()
      },
      formatDateStampa: function (date) {
        return moment(date).format('DD/MM/YYYY')
      }
    }
  }
</script>

<style lang="less">
  @import "../assets/less/variabili.less";
  @import "../assets/less/font.less";

  .modal-open {
    padding-right: 0px !important;
  }

  #ads {
    .bottone {
      cursor: pointer;
      width: 215px;
      background-color: @lightBlack;
      border-color: @lightBlack;
      margin-left: 1px;
      text-align: center;
      display: inherit;
      letter-spacing: 1px;
      .set-font(@color: @lightGold)
    }
    .closeButton{
      background-color: @lightBlack;
      border-color: @lightBlack;
      font-size: 30px;
      font-family: 'Lato-Light';
    }
    .modal-lg {
      max-width: 1200px;
    }
    .modal-content {
      background-color: @lightBlack;
      .modal-header {
        display: none !important;
        border-bottom: 0px;
        .close {
          color: white;
        }
      }
      .modal-body {
        display: flex;
        padding: 0px;
        width: 100%;
        .subscribe {
          padding-left: 50px;
          padding-top: 30px;
          .title {
            .set-font-title(@size: 34px)
          }
          .text {
            .set-font()
          }
          .form-control {
            width: 60%;
            margin: auto;
          }
          .iscriviti {
            text-align: center;
            padding-top: 30px;
            .bottone {
              width: 230px;
              background-color: @myOrange;
              border-color: @borderOrange;
              margin: auto;
              text-align: center;
              display: inherit;
              letter-spacing: 1px;
              .set-font()
            }
          }
        }
      }
      .modal-footer {
        display: none !important;
        border-bottom: 0px;
      }
      #modal-center {
      }
    }
    .modal-backdrop.show {
      opacity: 0.7;
    }
  }

  @media (max-width: 767px) {
    #ads {
      .bottone {
        .set-font(@size: 16px, @color: @lightGold)
      }
      .closeButton{
        background-color: @lightBlack;
        border-color: @lightBlack;
        font-size: 17px;
      }
      .modal-content {
        .modal-header {
          .close {
          }
        }
        .modal-body {
          .subscribe {
            padding-left: 30px;
            .title {
              .set-font-title(@size: 17px)
            }
            .text {
              padding-bottom: 30px;
              .set-font(@size: 12px)
            }
            .form-control {
              width: 100%;
            }
            .iscriviti {
              text-align: center;
              padding-top: 30px;
              padding-bottom: 30px;
              .bottone {
                width: 130px;
                .set-font(@size: 12px)
              }
            }
          }
          .pic {
            width: 0px;
          }
        }
        .modal-footer {
          display: none !important;
          border-bottom: 0px;
        }
        #modal-center {
        }
      }
      .title {
        margin-bottom: 10px;
        .set-font-title(@size: 16px);
      }
      .text {
        padding-bottom: 20px;
        letter-spacing: 1px;
        .set-font(@size: 12px);
      }
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    #ads {
      .modal-content {
        .modal-header {
          .close {
          }
        }
        .modal-body {
          .subscribe {
            padding-left: 30px;
            .title {
              .set-font-title(@size: 26px)
            }
            .text {
              padding-bottom: 5px;
              .set-font(@size: 16px)
            }
            .form-control {
              width: 100%;
            }
            .iscriviti {
              text-align: center;
              padding-top: 10px;
              padding-bottom: 10px;
              .bottone {
                width: 130px;
                .set-font(@size: 12px)
              }
            }
          }
        }
        .modal-footer {
          display: none !important;
          border-bottom: 0px;
        }
        #modal-center {
        }
      }
      .title {
        margin-bottom: 10px;
        .set-font-title(@size: 16px);
      }
      .text {
        padding-bottom: 20px;
        letter-spacing: 1px;
        .set-font(@size: 12px);
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Ads.vue